module.exports = __webpack_public_path__ + "static/img/gd.5a9b5d94.svg";